import { defineComponent as _defineComponent } from 'vue'
import LinkButton from 'JS/components/LinkButton.vue';
import { IProductDetailProductJson } from 'JS/types/PDP';
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTitle',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
	product: IProductDetailProductJson;
}



const container = ref<HTMLElement | null>();

let resizeObserver: ResizeObserver;
onMounted(async () => {
	await nextTick();
	resizeObserver = new ResizeObserver((entries) => {
		handleResizeUpdate();
	});

	resizeObserver.observe(container.value);
	handleResizeUpdate();
});

onBeforeUnmount(() => {
	resizeObserver?.disconnect();
});

function handleResizeUpdate() {
	if (!container.value) return;

	const items = [...container.value.children];
	if (items.length < 2) return;

	const firstTop = items[0].getBoundingClientRect().top;

	const elementHeightAdjustment = 5;
	const hasWrapped = items.some(item => Math.abs(item.getBoundingClientRect().top - firstTop) > elementHeightAdjustment );

	container.value.classList.toggle('is-wrapped', hasWrapped);

}


return { __sfc: true,props, container, resizeObserver, handleResizeUpdate, LinkButton }
}

})